var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40840",
    d: "M0.800049 33.2002H69.2001V63.2002C69.2001 66.5139 66.5138 69.2002 63.2001 69.2002H6.80005C3.48635 69.2002 0.800049 66.5139 0.800049 63.2002V33.2002Z",
    fill: "#12D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250695",
    d: "M26 16.9998V0.799805H44V16.9998L35 11.5998L26 16.9998Z",
    fill: "#12D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40841",
    d: "M35.0001 69.1998H6.80005C3.48634 69.1998 0.800049 66.5135 0.800049 63.1998V34.9998V6.79981C0.800049 3.4861 3.48634 0.799805 6.80005 0.799805H18.8H63.2001C66.5138 0.799805 69.2001 3.4861 69.2001 6.79981V16.9998V38.5998",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250697",
    d: "M56.1001 60.1996C56.1001 60.4758 56.324 60.6996 56.6001 60.6996C56.8762 60.6996 57.1001 60.4758 57.1001 60.1996H56.1001ZM56.9537 47.2461C56.7584 47.0508 56.4418 47.0508 56.2465 47.2461L53.0646 50.428C52.8693 50.6233 52.8693 50.9399 53.0646 51.1351C53.2598 51.3304 53.5764 51.3304 53.7717 51.1351L56.6001 48.3067L59.4285 51.1351C59.6238 51.3304 59.9404 51.3304 60.1356 51.1351C60.3309 50.9399 60.3309 50.6233 60.1356 50.428L56.9537 47.2461ZM57.1001 60.1996V47.5996H56.1001V60.1996H57.1001Z",
    fill: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.f12f378f1e03d387b04f3b2df6bc12f7.svg";
export { ForwardRef as ReactComponent };